// See web/app/themes/jcf-theme/templates/footer.twig

const scrollToTopBtn = document.querySelector(".scroll-to-top");
const scrollableHeight =
  document.documentElement.scrollHeight - document.documentElement.clientHeight;
const GOLDEN_RATIO = 0.2;

class ScrollToTop {
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  handleScroll = () => {
    if (document.documentElement.scrollTop / scrollableHeight > GOLDEN_RATIO) {
      scrollToTopBtn.classList.add("visible");
    } else {
      scrollToTopBtn.classList.remove("visible");
    }
  };

  init() {
    window.addEventListener("load", this.handleScroll);
    document.addEventListener("scroll", this.handleScroll);
    scrollToTopBtn.addEventListener("click", this.scrollToTop);
  }
}

export default ScrollToTop;
